<template><ListFilter field="research_scale" :options="opts" label="Масштаб исследований" @filter="$emit('filter',$event)" @openDetail="$emit('openDetail',$event)"/></template>
<script>
import ListFilter from './ListFilter.vue'
export default { name:'ResearchScaleFilter', components:{ListFilter}, data(){ return { opts:['Макро-КТ','Микро-КТ','Лаб. образец'] } } }
</script>
